// extracted by mini-css-extract-plugin
export default {"searchContainer":"InitialSearch-module_searchContainer__4NI9s","logo":"InitialSearch-module_logo__aQml5","loadingContainer":"InitialSearch-module_loadingContainer__BgO5a"};